const microsoftOutlookTriggerDefaults = {
  // Polling configuration
  pollMode: 'everyXMinutes',
  minuteInterval: 5,
  minute: 0,
  hour: 9,
  timezone: 'UTC',

  // Filters
  filterBySender: '',
  filterByReadStatus: 'all',
  filterHasAttachments: 'all',
  foldersToInclude: 'inbox',
  customODataFilter: '',

  // Output
  outputMode: 'simple',
  selectedFields: ['id', 'subject', 'from', 'to', 'receivedDateTime', 'bodyPreview', 'isRead', 'hasAttachments'],

  // Attachments
  downloadAttachments: false,
  maxAttachmentsPerMessage: 10,

  // Advanced
  advancedOptions: false,
  initialLookbackHours: 1,
  markAsRead: false,
  maxMessagesPerPoll: 100,
};

export default microsoftOutlookTriggerDefaults;
